module.exports = __webpack_public_path__ + "static/img/randomP.3b293f5d.gif";